
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { SignInHeader } from "./components/SignInHeader";
import { SignInForm } from "./components/SignInForm";
import { SignUpLink } from "./components/SignUpLink";
import { useAuthHandling } from "./hooks/useAuthHandling";
import { useToast } from "@/hooks/use-toast";

export const SignIn = () => {
  const navigate = useNavigate();
  const { loading, error, handleSignIn } = useAuthHandling();
  const { toast } = useToast();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) {
          console.error("Error checking session:", error);
          return;
        }
        
        if (session) {
          console.log("User already signed in, redirecting to home");
          navigate("/");
        }
      } catch (err) {
        console.error("Erreur lors de la vérification de la session:", err);
      }
    };
    checkSession();
  }, [navigate]);

  const handleGoogleSignIn = async () => {
    try {
      console.log("Starting Google sign-in process");
      
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth`,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
        }
      });

      if (error) {
        console.error("Google sign-in error details:", error);
        throw error;
      }
      
      console.log("Google sign-in initiated successfully");
    } catch (error: any) {
      console.error("Google sign-in error:", error);
      toast({
        variant: "destructive",
        title: "Erreur de connexion",
        description: error.message || "Une erreur est survenue lors de la connexion avec Google",
      });
    }
  };

  return (
    <Card className="w-full max-w-md mx-auto bg-white/80 backdrop-blur-sm border-0 shadow-lg">
      <SignInHeader />
      <CardContent>
        <SignInForm 
          onSubmit={handleSignIn}
          onGoogleSignIn={handleGoogleSignIn}
          error={error}
          loading={loading}
        />
        <SignUpLink />
      </CardContent>
    </Card>
  );
};
